export const TENANT_SETTINGS_PATH_NAME = 'tenant-settings';

export const TENANT_IP_ALLOWLIST_CACHE_TTL_SECONDS = 60 * 60;

export const tenantIpAllowlistCacheKey = ({
  tenantId,
}: {
  tenantId: string;
}): string => `global:tenant:ip-allowlist:${tenantId}`;

export const DEFAULT_REMEDIATION_CODING_TOOLS_PROMPT_TEMPLATE = [
  'You are helping remediate a security finding in this codebase.',
  '',
  '{{finding}}',
  '',
  '{{remediationPlan}}',
  '',
  'Inspect the current code before editing. Apply the smallest safe fix, add or update focused tests when appropriate, and do not blindly apply stale diffs.',
].join('\n');
